<template>
    <div>
        <div class="w-full py-20 border-t border-blue-light text-14">
            <template v-for="action in actions">
                <action :action="action" @complete="onComplete" @active="onActive"></action>
            </template>

            <span v-if="hasMore" @click="loadMore" class="block w-full mb-20 -mt-2 text-center bg-blue-light hover:bg-blue-lightest">
                <strong>Load more&hellip;</strong>
            </span>

            <div class="flex w-full" :class="{'mt-20' : actions.length > 0}">
                <div class="pr-10">
                    <img :src="user.avatar || `/images/placeholders/avatar.png`" :alt="client.name" class="w-40 h-40 mr-8 border rounded-full border-blue-light">
                </div>
                <!-- <div class="w-full">
                    <div class="relative">
                        <form>
                            <textarea v-model="newAction.text" placeholder="Add your action..." class="add-insight add-action"></textarea>
                            <input @click.prevent="onCreate" type="image" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC43OTEiIGhlaWdodD0iMTguNzkiIHZpZXdCb3g9IjAgMCAxOC43OTEgMTguNzkiPjxwYXRoIGQ9Ik0xOC4zODcuMTE1YS42NTUuNjU1LDAsMCwxLC4yODMuNjcxTDE1Ljk4NSwxNi44OTJhLjY2MS42NjEsMCwwLDEtLjMzNi40NzIuNjQ0LjY0NCwwLDAsMS0uMzI1LjA4NC43MDYuNzA2LDAsMCwxLS4yNTItLjA1MmwtNC43NS0xLjk0TDcuNzg2LDE4LjU0OWEuNjE3LjYxNywwLDAsMS0uNTE0LjI0MS41NjcuNTY3LDAsMCwxLS4yMzEtLjA0Mi42NzEuNjcxLDAsMCwxLS40NC0uNjI5VjE0LjQ2bDkuMDYtMTEuMS0xMS4yMDksOS43LTQuMTQyLTEuN2EuNjY0LjY2NCwwLDAsMS0uMDg0LTEuMkwxNy42NzQuMDk0QS42NDEuNjQxLDAsMCwxLDE4LjAwOSwwLC42NTEuNjUxLDAsMCwxLDE4LjM4Ny4xMTVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjExMSkiIGZpbGw9IiNmZmYiIG9wYWNpdHk9IjAuNiIvPjwvc3ZnPg==" alt="Post action..." />
                        </form>
                    </div>
                </div> -->
                <form-wrapper :validator="$v.newAction" class="w-full">
                    <form-group name="text" class="relative w-full">
                        <div class="w-full" slot-scope="{attributes}">
                            <textarea
                                v-model="newAction.text"
                                @input="delayTouch($v.newAction.text)"
                                v-bind="attributes"
                                placeholder="Add your action..."
                                class="w-full add-insight"
                            ></textarea>
                            <img @click.prevent="onCreate" class="cursor-pointer" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC43OTEiIGhlaWdodD0iMTguNzkiIHZpZXdCb3g9IjAgMCAxOC43OTEgMTguNzkiPjxwYXRoIGQ9Ik0xOC4zODcuMTE1YS42NTUuNjU1LDAsMCwxLC4yODMuNjcxTDE1Ljk4NSwxNi44OTJhLjY2MS42NjEsMCwwLDEtLjMzNi40NzIuNjQ0LjY0NCwwLDAsMS0uMzI1LjA4NC43MDYuNzA2LDAsMCwxLS4yNTItLjA1MmwtNC43NS0xLjk0TDcuNzg2LDE4LjU0OWEuNjE3LjYxNywwLDAsMS0uNTE0LjI0MS41NjcuNTY3LDAsMCwxLS4yMzEtLjA0Mi42NzEuNjcxLDAsMCwxLS40NC0uNjI5VjE0LjQ2bDkuMDYtMTEuMS0xMS4yMDksOS43LTQuMTQyLTEuN2EuNjY0LjY2NCwwLDAsMS0uMDg0LTEuMkwxNy42NzQuMDk0QS42NDEuNjQxLDAsMCwxLDE4LjAwOSwwLC42NTEuNjUxLDAsMCwxLDE4LjM4Ny4xMTVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjExMSkiIGZpbGw9IiNmZmYiIG9wYWNpdHk9IjAuNiIvPjwvc3ZnPg==" alt="Post insight..." />
                        </div>
                    </form-group>
                </form-wrapper>
            </div>
        </div>
    </div>
</template>

<script>
    import Action from './action'
    import { get, call } from 'vuex-pathify'
    import { between, maxLength, minLength, required } from "vuelidate/lib/validators"
    import validationMixin from "../../../../mixins/validation"

    export default {
        props: {
            value: {
                type: Array,
                required: true
            },

            total: {
                type: Number,
                required: true
            },
        },

        mixins: [validationMixin],

        components: {
            Action,
        },

        data() {
            return {
                newAction: {
                    text: null,
                }
            }
        },

        computed: {
            client: get('auth/client'),
            user: get('auth/user'),

            hasMore() {
                return this.total > this.actions.length
            },

            actions() {
                return this.value
            }
        },

        methods: {
            loadMore() {
                this.$emit('loadmore')
            },

            onActive(action) {
                this.$emit('active', action)
            },

            onComplete(action) {
                this.$emit('complete', action)
            },

            onCreate() {
                this.$v.newAction.$touch()

                if (!this.$v.newAction.$invalid) {
                    this.$emit('create', this.newAction)

                    this.$v.$reset()

                    this.newAction.text = null
                }
            },
        },

        validations: {
            newAction: {
                text: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(300),
                },
            }
        }
    }
</script>
